/* eslint-disable no-console */
import { call, put, select } from 'redux-saga/effects'
import firebase from 'firebase/app'
import moment from 'moment'

import ItemSyncActions from '../reducers/itemSyncReducer'

export function* getItemSync({ merchantKey }) {
  const itemSyncsRef = firebase.firestore().collection('item_syncs')
  const itemSyncMerchantRef = itemSyncsRef.doc(merchantKey)

  try {
    const snapshot = yield call([itemSyncMerchantRef, itemSyncMerchantRef.get])
    let itemSync = null
    if (snapshot.exists) {
      itemSync = snapshot.data()
    } else {
      const nowTimestamp = Number(moment().format('x'))
      const itemSyncRef = firebase
        .firestore()
        .collection('item_syncs')
        .doc(merchantKey)
      yield call([itemSyncRef, itemSyncRef.set], {
        last_updated_at: nowTimestamp,
      })
      const itemSyncSnapshot = yield call([itemSyncMerchantRef, itemSyncMerchantRef.get])
      itemSync = itemSyncSnapshot.data()
    }

    yield put(ItemSyncActions.getItemSyncSuccess(itemSync))
  } catch (error) {
    yield put(ItemSyncActions.getItemSyncError(error))
  }
}

export function* setLastUpdate() {
  const { data: itemSync, merchantKey } = yield select(state => state.itemSync)
  try {
    firebase
      .firestore()
      .collection('item_syncs')
      .doc(merchantKey)
      .update({
        ...itemSync,
        last_updated_at: Number(moment().format('x')),
      })
  } catch (err) {
    console.log(err)
  }
}

export function* syncMerchantItems() {
  const itemSync = yield select(state => state.itemSync)
  const { merchantKey, data } = itemSync

  const itemSyncMerchantRef = firebase
    .firestore()
    .collection('item_syncs')
    .doc(merchantKey)

  const sycnFunction = firebase
    .app()
    .functions('asia-northeast1')
    .httpsCallable('syncItemToHasura')

  try {
    const response = yield call(sycnFunction, { merchantKey })
    if (response !== null) {
      const nowTimestamp = Number(moment().format('x'))

      const params = {
        ...data,
        synced_at: nowTimestamp,
        last_updated_at: nowTimestamp,
      }

      yield call([itemSyncMerchantRef, itemSyncMerchantRef.set], params)
      yield put(ItemSyncActions.syncMerchantItemsSuccess())
    }
  } catch (error) {
    yield put(ItemSyncActions.syncMerchantItemsError(error))
  }
}



// WEBPACK FOOTER //
// ./src/sagas/itemSyncSaga.js